export { default } from "./Socials";
export * from "./Socials";
